import { packageService } from '../../helpers/services/package.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, ddlHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PACKAGE_MODULE = 'package';

// define action 
export const GET_ALL_PACKAGES = 'getAllPackages';
export const GET_PACKAGE = 'getPackage';
export const UPDATE_PACKAGE = 'updatePackage';
export const CREATE_PACKAGE = 'createPackage';
export const UPDATE_PACKAGE_STATUS = 'updatePackageStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PACKAGES_REQUEST = "getAllPackages";
const GET_PACKAGE_REQUEST = "getPackage";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PACKAGES]({ commit }, { filter }) {
        await packageService
            .getAllPackages(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PACKAGES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_PACKAGE]({ commit }, { id }) {
        await packageService
            .getPackage(id)
            .then(
                (result) => {
                    commit(GET_PACKAGE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PACKAGE]({ commit }, { data }) {
        commit(REQUEST)
        packageService
            .updatePackage(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.package')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PACKAGE]({ commit }, { data }) {
        commit(REQUEST)
        packageService
            .createPackage(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.package')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PACKAGE_STATUS]({ dispatch }, { filter, data }) {
        packageService
            .updatePackageStatua(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PACKAGES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Package-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PACKAGES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name, // not array
                localeName: o.locale_name,
                pricingID: o.pricing_id,
                value: o.value,
                isStartTogether: o.is_start_together,
                isActive: o.is_active,
                isRebookNeeded: o.is_rebook_needed,
                description: o.description,
                afterServiceDescription: o.after_service_description,
                image: o.image,
                company: o.company,
                packageServices: o.package_services,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                createdBy: o.created_by,
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PACKAGE_REQUEST](state, data) {
        let o = data.data

        const languages = ddlHelper.getLanguages();

        var names = null;

        if (o.locale_name != null) {
            names = [];
            Object.keys(o.locale_name.name).forEach(key => {
                names.push({ language: languages.find(lang => lang.code === key), name: o.locale_name.name[key] });
            });
        }
        else {
            names = []
        }

        console.log(o);

        state.details = {
            uuid: o.uuid,
            name: o.name, // not array
            localeName: o.locale_name,
            pricingID: o.pricing_id,
            value: o.value,
            isStartTogether: o.is_start_together,
            isActive: o.is_active,
            isRebookNeeded: o.is_rebook_needed,
            description: o.description,
            afterServiceDescription: o.after_service_description,
            image: o.image,
            company: o.company,
            services: o.package_services != null
                ? o.package_services.map((packageService) => ({
                    uuid: { uuid: packageService.service != null ? packageService.service.uuid : '', text: packageService.service != null ? packageService.service.name : '', },
                    quantity: packageService.quantity
                }))
                : [],
            packageServices: o.package_services,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            createdBy: o.created_by,
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            names: names,
            companyID: o.company != null ? {
                value: o.company.uuid,
                text: o.company.name
            } : '',
        }
    }
}


